import request from '@/utils/request'

// 查询维修产品列表分页
export function fetchList(query) {
    return request({
        url: '/upkeep/prod/page',
        method: 'get',
        params: query,
    })
}
// 查询维修产品详细
export function getObj(id) {
    return request({
        url: '/upkeep/prod/detail?id=' + id,
        method: 'get',
    })
}
// 查询维修产品详细
export function prodInventory(id) {
    return request({
        url: '/upkeep/prod/detail?id=' + id,
        method: 'get',
    })
}

// 新增维修产品
export function addObj(data) {
    return request({
        url: '/upkeep/prod/add',
        method: 'post',
        data: data,
    })
}
// 禁用启用 维修首页状态
export function statusObj(data) {
    return request({
        url: '/upkeep/script/status',
        method: 'post',
        data: data,
    })
}
// 修改维修产品
export function putObj(data) {
    return request({
        url: '/upkeep/prod/edit',
        method: 'post',
        data: data,
    })
}
// 删除维修产品
export function delObj(data) {
    return request({
        url: '/upkeep/prod/delete',
        method: 'post',
        data: data,
    })
}
